import { render, staticRenderFns } from "./PalletFilters.vue?vue&type=template&id=6a34e52a&scoped=true"
import script from "./PalletFilters.vue?vue&type=script&lang=ts"
export * from "./PalletFilters.vue?vue&type=script&lang=ts"
import style0 from "./PalletFilters.vue?vue&type=style&index=0&id=6a34e52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34e52a",
  null
  
)

export default component.exports